export default function LogoMark({ className = "w-20 h-20" }) {
  return (
    <img
      src="/logo-mark.png"
      alt="Sports Sweat"
      data-testid="logo-mark"
      className={`${className} object-contain`}
      style={{ filter: "drop-shadow(0 8px 22px rgba(0,0,0,.4))" }}
    />
  );
}
